import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const playerNotesCell = style({
  padding: `0 ${vars.space["2xs"]}`,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      padding: `${vars.space.s} ${vars.space.m}`,
    },
  },
});
